// ---------- Compra anónima de Compatibilidad Astral (sinastría) ----------
// Paso 1: crear la sinastría pendiente (calcula y persiste, sin entregar).
// `personA` / `personB` traen { name, birthDate, birthTime, birthCity,
// birthCountry, lat, lng } (misma forma que standaloneSynastryRequest).
export const CREATE_PENDING_SINASTRIA_REQUEST = 'SINASTRIA/CREATE_PENDING_REQUEST';
export const createPendingSinastriaRequest = (email, personA, personB) =>
  ({ type: CREATE_PENDING_SINASTRIA_REQUEST, payload: {
    email,
    person_a_name: personA.name, person_a_birth_date: personA.birthDate, person_a_birth_time: personA.birthTime,
    person_a_birth_city: personA.birthCity, person_a_birth_country: personA.birthCountry,
    person_a_lat: personA.lat, person_a_lng: personA.lng,
    person_b_name: personB.name, person_b_birth_date: personB.birthDate, person_b_birth_time: personB.birthTime,
    person_b_birth_city: personB.birthCity, person_b_birth_country: personB.birthCountry,
    person_b_lat: personB.lat, person_b_lng: personB.lng,
  }});
export const CREATE_PENDING_SINASTRIA_SUCCESS = 'SINASTRIA/CREATE_PENDING_SUCCESS';
export const createPendingSinastriaSuccess = (readingId) =>
  ({ type: CREATE_PENDING_SINASTRIA_SUCCESS, payload: { readingId } });
export const CREATE_PENDING_SINASTRIA_FAILURE = 'SINASTRIA/CREATE_PENDING_FAILURE';
export const createPendingSinastriaFailure = (error) =>
  ({ type: CREATE_PENDING_SINASTRIA_FAILURE, payload: error });

// Paso 2: checkout (Stripe / PayPal)
export const SINASTRIA_CHECKOUT_REQUEST = 'SINASTRIA/CHECKOUT_REQUEST';
export const sinastriaCheckoutRequest = (email, readingId) =>
  ({ type: SINASTRIA_CHECKOUT_REQUEST, payload: { email, reading_id: readingId } });
export const SINASTRIA_CHECKOUT_SUCCESS = 'SINASTRIA/CHECKOUT_SUCCESS';
export const sinastriaCheckoutSuccess = () => ({ type: SINASTRIA_CHECKOUT_SUCCESS });
export const SINASTRIA_CHECKOUT_FAILURE = 'SINASTRIA/CHECKOUT_FAILURE';
export const sinastriaCheckoutFailure = (e) => ({ type: SINASTRIA_CHECKOUT_FAILURE, payload: e });

export const SINASTRIA_PAYPAL_REQUEST = 'SINASTRIA/PAYPAL_REQUEST';
export const sinastriaPaypalOrderRequest = (email, readingId) =>
  ({ type: SINASTRIA_PAYPAL_REQUEST, payload: { email, reading_id: readingId } });
export const SINASTRIA_PAYPAL_SUCCESS = 'SINASTRIA/PAYPAL_SUCCESS';
export const sinastriaPaypalOrderSuccess = () => ({ type: SINASTRIA_PAYPAL_SUCCESS });
export const SINASTRIA_PAYPAL_FAILURE = 'SINASTRIA/PAYPAL_FAILURE';
export const sinastriaPaypalOrderFailure = (e) => ({ type: SINASTRIA_PAYPAL_FAILURE, payload: e });

// Paso 3: verificar el pago al volver del checkout
export const SINASTRIA_VERIFY_REQUEST = 'SINASTRIA/VERIFY_REQUEST';
export const sinastriaVerifyPurchaseRequest = (sessionId) =>
  ({ type: SINASTRIA_VERIFY_REQUEST, payload: { session_id: sessionId } });
export const SINASTRIA_VERIFY_SUCCESS = 'SINASTRIA/VERIFY_SUCCESS';
export const sinastriaVerifyPurchaseSuccess = (data) =>
  ({ type: SINASTRIA_VERIFY_SUCCESS, payload: data });
export const SINASTRIA_VERIFY_FAILURE = 'SINASTRIA/VERIFY_FAILURE';
export const sinastriaVerifyPurchaseFailure = (e) => ({ type: SINASTRIA_VERIFY_FAILURE, payload: e });

export const SINASTRIA_VERIFY_PAYPAL_REQUEST = 'SINASTRIA/VERIFY_PAYPAL_REQUEST';
export const sinastriaVerifyPaypalRequest = (paypalOrderId) =>
  ({ type: SINASTRIA_VERIFY_PAYPAL_REQUEST, payload: { paypal_order_id: paypalOrderId } });
export const SINASTRIA_VERIFY_PAYPAL_SUCCESS = 'SINASTRIA/VERIFY_PAYPAL_SUCCESS';
export const sinastriaVerifyPaypalSuccess = (data) =>
  ({ type: SINASTRIA_VERIFY_PAYPAL_SUCCESS, payload: data });
export const SINASTRIA_VERIFY_PAYPAL_FAILURE = 'SINASTRIA/VERIFY_PAYPAL_FAILURE';
export const sinastriaVerifyPaypalFailure = (e) => ({ type: SINASTRIA_VERIFY_PAYPAL_FAILURE, payload: e });

// Reset (volver a empezar el flujo en la misma sesión)
export const SINASTRIA_PURCHASE_RESET = 'SINASTRIA/PURCHASE_RESET';
export const sinastriaPurchaseReset = () => ({ type: SINASTRIA_PURCHASE_RESET });
